// extracted by mini-css-extract-plugin
export default {"background-list":"BackgroundList_background-list__RhA-f"};